export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiaW1hZ2VzL2ljLXBsYW4tYmlvZGVjaGV0cy5zdmciOw=="